import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class OrderConfirmation extends Component {
    render() {
        return (
            <div className="ps-order-preview-page">
                <div className="ps-categogy ps-categogy--separate">
                    <div className="container whiteContainer">
                        <div className="row">
                            <div className="col-12">
                                <ul className="ps-breadcrumb ps-order-preview-page__breadcrumb">
                                    <li className="ps-breadcrumb__item"><Link to="/">Home</Link></li>
                                    <li className="ps-breadcrumb__item"><Link to="/orders">My Orders</Link></li>
                                    <li className="ps-breadcrumb__item active"><span>Order preview</span></li>
                                </ul>
                            </div>

                            <div className="col-12">
                                <section className="ps-order-preview-hero">
                                    <div className="ps-order-preview-hero__visual">
                                        <div className="ps-order-preview-hero__badge">
                                            <i className="fa fa-check" aria-hidden="true"></i>
                                        </div>
                                        <img
                                            src="/assets/img/Purchase_Success.png"
                                            className="ps-order-preview-hero__image"
                                            alt="Order confirmed"
                                        />
                                    </div>

                                    <div className="ps-order-preview-hero__content">
                                        <span className="ps-order-preview-hero__eyebrow">Order confirmed</span>
                                        <h1>Thank you for your order</h1>
                                        <p>
                                            Your payment was successful and your order is now being prepared.
                                            We will send an email and SMS with the latest delivery updates.
                                        </p>

                                        <div className="ps-order-preview-hero__stats">
                                            <div className="ps-order-preview-stat">
                                                <span>Status</span>
                                                <strong>Confirmed</strong>
                                            </div>
                                            <div className="ps-order-preview-stat">
                                                <span>Next update</span>
                                                <strong>By SMS / Email</strong>
                                            </div>
                                            <div className="ps-order-preview-stat">
                                                <span>Expected flow</span>
                                                <strong>Processing to delivery</strong>
                                            </div>
                                        </div>

                                        <div className="ps-order-preview-hero__actions">
                                            <Link to="/orders" className="ps-btn ps-btn--sm ps-btn--warning ps-order-preview-hero__btn">
                                                View order
                                            </Link>
                                            <Link to="/" className="ps-btn ps-btn--sm ps-btn--outline ps-order-preview-hero__btn ps-order-preview-hero__btn--secondary">
                                                Continue shopping
                                            </Link>
                                        </div>
                                    </div>
                                </section>

                                <section className="ps-order-preview-grid">
                                    <article className="ps-order-preview-card">
                                        <div className="ps-order-preview-card__header">
                                            <span className="ps-order-preview-card__eyebrow">What happens next</span>
                                            <h2>Simple order flow</h2>
                                        </div>

                                        <div className="ps-order-preview-steps">
                                            <div className="ps-order-preview-step">
                                                <div className="ps-order-preview-step__index">1</div>
                                                <div className="ps-order-preview-step__body">
                                                    <strong>Order received</strong>
                                                    <p>We have locked the order and started processing it in our system.</p>
                                                </div>
                                            </div>
                                            <div className="ps-order-preview-step">
                                                <div className="ps-order-preview-step__index">2</div>
                                                <div className="ps-order-preview-step__body">
                                                    <strong>Preparation and packing</strong>
                                                    <p>Your items are prepared carefully and packed for dispatch.</p>
                                                </div>
                                            </div>
                                            <div className="ps-order-preview-step">
                                                <div className="ps-order-preview-step__index">3</div>
                                                <div className="ps-order-preview-step__body">
                                                    <strong>Delivery updates</strong>
                                                    <p>You will receive tracking and delivery status updates as soon as they are available.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </article>

                                    <article className="ps-order-preview-card ps-order-preview-card--summary">
                                        <div className="ps-order-preview-card__header">
                                            <span className="ps-order-preview-card__eyebrow">Helpful links</span>
                                            <h2>Manage your purchase</h2>
                                        </div>

                                        <div className="ps-order-preview-links">
                                            <Link to="/orders" className="ps-order-preview-link">
                                                <span className="ps-order-preview-link__icon"><i className="fa fa-list" aria-hidden="true"></i></span>
                                                <span className="ps-order-preview-link__text">
                                                    <strong>View all orders</strong>
                                                    <small>Check status, history, and delivery progress</small>
                                                </span>
                                            </Link>

                                            <Link to="/account" className="ps-order-preview-link">
                                                <span className="ps-order-preview-link__icon"><i className="fa fa-user" aria-hidden="true"></i></span>
                                                <span className="ps-order-preview-link__text">
                                                    <strong>Open account</strong>
                                                    <small>Review profile, addresses, and saved details</small>
                                                </span>
                                            </Link>

                                            <Link to="/cart" className="ps-order-preview-link">
                                                <span className="ps-order-preview-link__icon"><i className="fa fa-shopping-cart" aria-hidden="true"></i></span>
                                                <span className="ps-order-preview-link__text">
                                                    <strong>Return to cart</strong>
                                                    <small>Continue with items you were browsing earlier</small>
                                                </span>
                                            </Link>
                                        </div>
                                    </article>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default OrderConfirmation;
